import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ComissaoService } from '../comissao.service';
import { TipoComissao } from '../models/comissao';


@Component({
  selector: 'app-tipo-comissao',
  templateUrl: './tipo-comissao.component.html',
  styleUrls: ['./tipo-comissao.component.scss']
})
export class TipoComissaoComponent implements OnInit {
    
    constructor(private comissaoService : ComissaoService, private router: Router, private route: ActivatedRoute, private activateRoute: ActivatedRoute) { }
  
    public listaTipoComissao: TipoComissao[];
    
    ngOnInit(): void {
       this.getTiposComissao();    
    }
  
    getTiposComissao(){
      this.comissaoService.getTiposComissao().subscribe(
        (res) => {
          if (res) {            
            this.listaTipoComissao = res; 
          }
        },
        err => {
          console.log("TipoComissaoList - TiposComissao");
          console.log(err);
        }
      );
    }
  
  }
  